<template>
    <el-card shadow="hover">
        <label slot="header">时间范围 {{`${starttime} - ${endtime}`}}</label>
        <el-divider content-position="left">:start.sync="starttime" :end.sync="endtime"</el-divider>
        <j-date-range :start.sync="starttime" :end.sync="endtime"/>
        <el-divider content-position="left">时分秒 value-format="yyyy-MM-dd HH:mm:ss"</el-divider>
        <j-date-range :start.sync="starttime" :end.sync="endtime" value-format="yyyy-MM-dd HH:mm:ss" />
        <el-divider content-position="left">可选参数'before', 'after', 'before-today', 'after-today'，禁用今天之前/之后的日期 disabledRange="after"</el-divider>
        <j-date-range :start.sync="starttime" :end.sync="endtime" disabledRange="after" />
        <el-divider content-position="left">快速选择过去几天，快捷按钮数组，内部数字代表天数 :before-shortcuts="[3,5,7]"</el-divider>
        <j-date-range :start.sync="starttime" :end.sync="endtime" :before-shortcuts="[3,5,7]" />
        <el-divider content-position="left">快速选择未来几天，快捷按钮数组，内部数字代表天数 :after-shortcuts="[7,30,90]"</el-divider>
        <j-date-range :start.sync="starttime" :end.sync="endtime" :after-shortcuts="[7,30,90]" />
        <el-divider content-position="left">绑定v-model返回逗号,分割的时间字符串（特殊场景使用）</el-divider>
        <j-date-range v-model="dateStr" value-format="yyyy-MM-dd HH:mm:ss"/>
        <el-divider content-position="left">月份范围type="monthrange" value-format="yyyy-MM"</el-divider>
        <j-date-range type="monthrange" :start.sync="starMonth" :end.sync="endMonth" value-format="yyyy-MM" :before-shortcuts="[3,5,12]" :after-shortcuts="[1,3,9,12]"/>
        <el-divider content-position="left">带时分秒设置type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"</el-divider>
        <j-date-range type="datetimerange" :start.sync="starTime" :end.sync="endTime" value-format="yyyy-MM-dd HH:mm:ss"/>
    </el-card>
</template>

<script>
    import JDateRange from "./JDateRange";
    export default {
        components: {
            JDateRange
        },
        data() {
            return {
                dateStr: '2022-06-10 00:00:00,2022-07-07 23:59:59',
                starttime: '',
                endtime: '',
                starMonth: '',
                endMonth: '',
                starTime: '',
                endTime: ''
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
